import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticateDomainService } from 'src/app/private/services/authenticate-domain.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { UsersService } from 'src/app/private/services/users.service';
import { ClientService } from 'src/app/private/services/client.service';
import { forkJoin } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-email-config',
  templateUrl: './email-config.component.html',
  styleUrls: ['./email-config.component.scss']
})
export class EmailConfigComponent implements OnInit {

  emailForm!: FormGroup;
  activeDomains: any[] = [];
  orgEmailsuccess: string = '';
  selectedProvider = 'ses';
  previousProvider = 'ses';
  selectedId: any;
  passwordVisible: any = {};
  is_default: boolean = false;

  // 🔹 ADD EMAIL STATE
  newOrgEmail = '';
  newEmailType: 'notification' | 'communication' | 'campaign' = 'notification';
  selectedUserId: string | null = null;

  nameRegex = /^[a-zA-Z0-9._-]+$/;
  fromEmailError = '';
  primaryNameError = '';
  orgEmailError = '';
  btnLoading = false;

  // 🔹 USERS (COMMUNICATION TYPE)
  users: any[] = [];

  // 🔹 PREDEFINED EMAIL PREFIXES (RESTRICTED)
  emailPrefixes = [
    { value: 'info', label: 'info', type: ['notification'], description: 'General information emails' },
    { value: 'notification', label: 'notification', type: ['notification'], description: 'System notifications' },
    { value: 'marketing', label: 'marketing', type: ['campaign'], description: 'Marketing campaigns' },
    { value: 'hello', label: 'hello', type: ['campaign'], description: 'Welcome & greeting emails' },
    { value: 'update', label: 'update', type: ['campaign'], description: 'Product updates' },
    { value: 'news', label: 'news', type: ['campaign'], description: 'Newsletter & announcements' },
    { value: 'noreply', label: 'noreply', type: ['notification'], description: 'No-reply notifications' }
  ];

  providers = [
    { key: 'ses', label: 'Primary' },
    // { key: 'azure', label: 'Microsoft Azure' },
    // { key: 'sendgrid', label: 'Send Grid' }
  ];

  EMAIL_PROVIDER_FIELDS: any = {
    ses: [
      { key: 'host', type: 'text',label:'Host' },
      { key: 'port', type: 'text' ,label:'Port'},
      { key: 'user', type: 'text' ,label:'Username'},
      { key: 'password', type: 'password', secure: true ,label:'Password'},
      { key: 'from_email', type: 'email' ,label:'From Email'},
      { key: 'reply_to_email', type: 'email' ,label:'Reply To' }
    ],
    azure: [
      { key: 'host', type: 'text',label:'Host' },
      { key: 'port', type: 'text' ,label:'Port'},
      { key: 'user', type: 'text' ,label:'Username'},
      { key: 'password', type: 'password', secure: true ,label:'Password'},
      { key: 'from_email', type: 'email' ,label:'From Email'},
      { key: 'reply_to_email', type: 'email' ,label:'Reply To' }
    ],
    sendgrid: [
      { key: 'host', type: 'text',label:'Host' },
      { key: 'port', type: 'text' ,label:'Port'},
      { key: 'user', type: 'text' ,label:'Username'},
      { key: 'password', type: 'password', secure: true ,label:'Password'},
      { key: 'from_email', type: 'email' ,label:'From Email'},
      { key: 'reply_to_email', type: 'email' ,label:'Reply To' }
    ]
  };
  clientName = '';

  isPageLoading = true;

  constructor(
    private fb: FormBuilder,
    private localStorage: LocalStorageService,
    private domainService: AuthenticateDomainService,
    private router: Router,
    private toastr: ToastrService,
        private userApi: UsersService,
        private clientService : ClientService,
    private modalService:NgbModal    
  ) {

    this.clientName = this.localStorage.getClientName();
  }

  ngOnInit(): void {
    this.buildForm();
    
   const payload = { hospital_id: this.localStorage.getHospitalId()};

   const paylaod2 = {
    "where": {
        "hospital_id": this.localStorage.getHospitalId(),
        "center_id": this.localStorage.getCenterId()
    },
    "page": 0,
    "limit": 1000,
    "filter": null
}
   
  forkJoin({
    domains: this.domainService.getAllClientDomain(payload),
    users: this.userApi.findAllUsers(paylaod2),
    config: this.clientService.getAllClientConfig({
      where: { hospital_id: this.localStorage.getHospitalId()},
      order: { col: '', dir: '' }
    })
  }).subscribe({
    next: ({ domains, users, config }) => {
      this.activeDomains = domains || [];

      // Success
      this.activeDomains = this.activeDomains.filter((d: any) => d.status == "Success");

      console.log("All Users:", users);

      this.users = users.rows || [];

      const emailConfig = this.getActiveEmailConfig(config);
      this.populateForm(emailConfig);
      this.isPageLoading = false;
    },
    error: err => {
      console.error(err);
      this.isPageLoading = false;
    }
  });
  }


togglePassword(key: string) {
  this.passwordVisible[key] = !this.passwordVisible[key];
}

changePref(model:any){
  this.modalService.open(model, {
      size: 'l',
      scrollable: true,
      centered: true,
    });
}

beforeProviderChange(provider: string) {
  if (provider !== this.previousProvider) {

    const confirmed = confirm(
      'Are you sure you want to change configuration?'
    );

    if (!confirmed) {
      this.selectedProvider = this.previousProvider;
      return;
    }

    this.selectedProvider = provider;
    this.previousProvider = provider;

    this.emailConfigArray.controls.forEach(c =>
      c.patchValue({ is_active: c.value.provider === provider })
    );
  }
}
  goToDomainAuthentication() {
    this.router.navigate(['/main/domain-authentication']);
  }

  /* ---------------- FORM BUILD ---------------- */

  buildForm() {
    this.emailForm = this.fb.group({
      email_config: this.fb.array(
        this.providers.map(p => this.createProviderGroup(p.key))
      )
    });
  }

  createProviderGroup(provider: string): FormGroup {
    const settings: any = {};

    this.EMAIL_PROVIDER_FIELDS[provider].forEach((f: any) => {
      settings[f.key] = [''];
      if (f.secure) this.passwordVisible[f.key] = false;
    });

    if (provider === 'ses') {
      settings.authenticated_domain = [''];
    }

    settings.client_name = [''];
    settings.client_complement = [''];
    settings.speciality_title = [''];
    settings.support_email = [''];

    // 🔥 UPDATED: organisation_email as OBJECT ARRAY
    settings.organisation_email = this.fb.array([]);

    return this.fb.group({
      provider: [provider],
      is_active: [provider === this.selectedProvider],
      settings: this.fb.group(settings)
    });
  }

  /* ---------------- GETTERS ---------------- */

  get emailConfigArray(): FormArray {
    return this.emailForm.get('email_config') as FormArray;
  }

  get providerForm(): FormGroup {
    return this.emailConfigArray.controls.find(
      (c: any) => c.value.provider === this.selectedProvider
    ) as FormGroup;
  }

  get settingsForm(): FormGroup {
    return this.providerForm.get('settings') as FormGroup;
  }

  get organisationEmails(): FormArray {
    return this.settingsForm.get('organisation_email') as FormArray;
  }

  get isDomainSelected(): boolean {
    return !!this.settingsForm.get('authenticated_domain')?.value;
  }

  get selectedDomain(): string {
    return this.settingsForm.get('authenticated_domain')?.value || '';
  }

  isActiveProvider(providerKey: string): boolean {
    const control = this.emailConfigArray.controls.find(
      (c: any) => c.value.provider === providerKey
    );
    return control ? control.value.is_active : false;
  }

  /**
   * Get available email prefixes based on selected email type
   */
  get availableEmailPrefixes() {
    return this.emailPrefixes.filter(prefix => 
      prefix.type.includes(this.newEmailType)
    );
  }

  /* ---------------- VALIDATIONS ---------------- */

  validateOrgEmailName(name: string): boolean {
    // Check if the prefix is in the allowed list
    const isValidPrefix = this.emailPrefixes.some(prefix => prefix.value === name);
    
    if (!isValidPrefix) {
      this.orgEmailError = 'Please select a valid email prefix from the dropdown.';
      return false;
    }
    
    // Check if prefix is allowed for selected type
    const prefix = this.emailPrefixes.find(p => p.value === name);
    if (prefix && !prefix.type.includes(this.newEmailType)) {
      this.orgEmailError = `The prefix "${name}" is not allowed for ${this.newEmailType} emails.`;
      return false;
    }
    
    this.orgEmailError = '';
    return true;
  }

  validateFromEmailName(name: string): boolean {
    if (!name.match(this.nameRegex)) {
      this.fromEmailError =
        'Special characters not allowed. Must be a valid email username.';
      return false;
    }
    this.fromEmailError = '';
    return true;
  }

  /* ---------------- ADD ORG EMAIL (UPDATED) ---------------- */

  addOrgEmail() {
    const domain = this.selectedDomain;

    if (!domain) {
      this.orgEmailError = 'Please select a domain first';
      return;
    }

    if (!this.newOrgEmail) {
      this.orgEmailError = 'Email username is required';
      return;
    }

    if (!this.validateOrgEmailName(this.newOrgEmail)) return;

    if (this.newEmailType === 'communication' && !this.selectedUserId) {
      this.orgEmailError = 'Select user for communication email';
      return;
    }

    const fullEmail = `${this.newOrgEmail}@${domain}`;

    const exists = this.organisationEmails.value.some(
      (e: any) => e.email === fullEmail
    );
    if (exists) {
      this.orgEmailError = 'Email already exists';
      return;
    }
    //this.btnLoading = true;
    this.orgEmailsuccess = '';
    // this.domainService.verifyDomainEmail({
    //   email: fullEmail
    // }).subscribe({
    //   next: (res: any) => {
    //     console.log('Email verification response:', res);
    //     this.btnLoading = false;
    //     if (res.$metadata && res.$metadata.httpStatusCode === 200) {
    //        this.orgEmailsuccess = 'Email added successfully. Please verify it from your inbox.';
    //        setTimeout(() => {
    //         this.orgEmailsuccess = '';
    //        }, 5000);
    //       this.pushNewOrgEmail(fullEmail);
    //     } else {
    //       this.orgEmailError = 'Email is not verified in the selected domain';
    //     }
    //   },
    //   error: (e: any) => {
    //     this.btnLoading = false;
    //     console.error('Error verifying email:', e);
    //     this.orgEmailError = 'Error verifying email. Please try again.';
    //   }
    // });
     this.pushNewOrgEmail(fullEmail);
  }

  pushNewOrgEmail(fullEmail: string) {

    const user = this.users.find(u => u.user_id === this.selectedUserId);

    this.organisationEmails.push(
      this.fb.group({
        email: [fullEmail],
        type: [this.newEmailType],
        user_id: [this.newEmailType === 'communication' ? this.selectedUserId : null],
        user_name: [this.newEmailType === 'communication' ? user?.fname+" "+user?.lname : null]
      })
    );

    // ✅ AUTO SET DEFAULT
    if (
      this.newEmailType === 'notification' &&
      !this.settingsForm.get('from_email')?.value
    ) {
      this.setDefaultFromEmail(fullEmail);
    }

    this.newOrgEmail = '';
    this.newEmailType = 'notification';
    this.selectedUserId = null;
  }

  /* ---------------- REMOVE EMAIL ---------------- */

  removeOrgEmail(email: string) {
    const index = this.organisationEmails.value.findIndex(
      (e: any) => e.email === email
    );
    if (index === -1) return;

    if (this.settingsForm.get('from_email')?.value === email) {
      this.settingsForm.patchValue({ from_email: '' });
    }

    this.organisationEmails.removeAt(index);
  }

  /* ---------------- DEFAULT FROM EMAIL ---------------- */

  setDefaultFromEmail(email: string) {
    const emailObj = this.organisationEmails.value.find(
      (e: any) => e.email === email
    );
    if (emailObj?.type !== 'notification') return;

    this.settingsForm.patchValue({ from_email: email });
  }

  /* ---------------- FROM EMAIL INPUT ---------------- */

  onFromEmailInput(event: any) {
    this.fromEmailError = '';
    const input = event.target.value;

    if (!this.validateFromEmailName(input)) return;

    const domain = this.selectedDomain;
    if (!domain) return;

    this.settingsForm.patchValue({
      from_email: `${input}@${domain}`
    });
  }

  /* ---------------- DOMAIN ---------------- */



  /* ---------------- SAVE ---------------- */

  save() {
    if (this.selectedProvider === 'ses' && !this.isDomainSelected) {
      this.toastr.error(
        'Please select an authenticated domain before saving.',
        'Error'
      );
      return;
    }

    const payload = {
      id: this.selectedId,
      hospital_id: this.localStorage.getHospitalId(),
      center_id: this.localStorage.getCenterId(),
      email_config: this.emailForm.value.email_config
    };

    this.btnLoading = true;
    console.log('FINAL PAYLOAD:', payload);
    
    // Check if configuration exists (selectedId is set)
    if (this.selectedId) {
      // Update existing configuration
      this.clientService.updateClientConfig(payload).subscribe({  
        next: (res: any) => {
          this.toastr.success('Email configuration updated successfully.', 'Success');
          this.btnLoading = false;
          // Update selectedId in case it changed
          if (res && res.id) {
            this.selectedId = res.id;
          }
        },
        error: (e: any) => {
          console.error('Error updating email configuration:', e);
          this.toastr.error('Failed to update email configuration. Please try again.', 'Error');
          this.btnLoading = false;
        }
      });
    } else {
      // Create new configuration
      this.clientService.createClientConfig(payload).subscribe({  
        next: (res: any) => {
          this.toastr.success('Email configuration created successfully.', 'Success');
          this.btnLoading = false;
          // Store the new ID for future updates
          if (res && res.id) {
            this.selectedId = res.id;
          }
        },
        error: (e: any) => {
          console.error('Error creating email configuration:', e);
          this.toastr.error('Failed to create email configuration. Please try again.', 'Error');
          this.btnLoading = false;
        }
      });
    }
  }

  /* ---------------- LOAD API DATA (BACKWARD SAFE) ---------------- */

  loadFormFromApi() {
    let payload: any = {

              where: {
                hospital_id: this.localStorage.getHospitalId()
              },
              order: {
                col: "",
                dir: ""
              }
            };
    this.clientService.getAllClientConfig(payload).subscribe({
      next: (res: any) => {
       const activeEmailConfig = this.getActiveEmailConfig(res);
       console.log('EMAIL CONFIG FROM API:', activeEmailConfig);
        this.populateForm(activeEmailConfig);

      },
      error: (e: any) => {
        console.error('Error loading client config:', e);
      }
    });
  }

  getActiveEmailConfig(response: any): any | null {
  if (
    !response ||
    !response.rows ||
    !response.rows.length ||
    !response.rows[0].email_config
  ) {
    return null;
  }

  console.log('EMAIL CONFIG FROM API:', response.rows[0].email_config);

  const emailConfigs = response.rows[0].email_config;
  this.selectedId = response.rows[0].id;
  this.is_default = (emailConfigs.is_default ? emailConfigs.is_default : false);

  return emailConfigs;
}
  populateForm(apiResponse: any[] | null) {
  if (!apiResponse || !Array.isArray(apiResponse)) return;

  console.log('API RESPONSE FOR EMAIL CONFIG:', apiResponse);

  apiResponse.forEach((config: any) => {

    const providerGroup = this.emailConfigArray.controls.find(
      (c: any) => c.get('provider')?.value === config.provider
    ) as FormGroup;

    if (!providerGroup) return;

    // ✅ Set active flag
    providerGroup.patchValue({
      is_active: config.is_active
    });

    // 🔥 IMPORTANT: Sync selectedProvider with active provider
    if (config.is_active) {
      this.selectedProvider = config.provider;
      this.previousProvider = config.provider;
    }

    const settingsGroup = providerGroup.get('settings') as FormGroup;
    if (!settingsGroup) return;

    // ✅ Patch all settings
    settingsGroup.patchValue(config.settings || {}, { emitEvent: false });

    // ✅ Explicit SES domain patch
    if (
      config.provider === 'ses' &&
      settingsGroup.get('authenticated_domain')
    ) {
      setTimeout(() => {
        settingsGroup
          .get('authenticated_domain')
          ?.setValue(config.settings?.authenticated_domain || '');
      }, 1000);
    
   
    }

    // ✅ Organisation emails
    const orgEmailsArray = settingsGroup.get('organisation_email') as FormArray;
    if (!orgEmailsArray) return;

    orgEmailsArray.clear();

    (config.settings?.organisation_email || []).forEach((email: any) => {
      orgEmailsArray.push(
        this.fb.group({
          email: [email?.email || email || ''],
          type: [email?.type || 'notification'],
          user_id: [email?.user_id || null],
          user_name: [email?.user_name || null]
        })
      );
    });
  });
}
}